import { render, staticRenderFns } from "./DailyRoutine.vue?vue&type=template&id=70a00650&scoped=true"
import script from "./DailyRoutine.vue?vue&type=script&lang=js"
export * from "./DailyRoutine.vue?vue&type=script&lang=js"
import style0 from "./DailyRoutine.vue?vue&type=style&index=0&id=70a00650&prod&scoped=true&lang=css"
import style1 from "./DailyRoutine.vue?vue&type=style&index=1&id=70a00650&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a00650",
  null
  
)

export default component.exports